export const DEMO_ROLE_IDS = new Set([3, 4]);

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getFallbackSectionId(sectionId) {
  if (sectionId) return Number(sectionId);

  const user = getStoredUser();

  return user?.section_id ? Number(user.section_id) : null;
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function getMessageId(message) {
  return message?.id ?? message?.message_id;
}

export function getMessageDate(message) {
  return (
    message?.created_at ||
    message?.createdAt ||
    message?.date_creation ||
    message?.date ||
    null
  );
}

export function formatDateTime(dateValue) {
  if (!dateValue) return "—";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDateShort(dateValue) {
  if (!dateValue) return "—";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
}

export function truncateText(value = "", max = 120) {
  const clean = String(value || "").trim();

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max).trim()}...`;
}

export function sortMessagesByDate(messages = []) {
  return [...messages].sort((a, b) => {
    const dateA = new Date(getMessageDate(a) || 0).getTime();
    const dateB = new Date(getMessageDate(b) || 0).getTime();

    return dateB - dateA;
  });
}

export function filterMessages(messages = [], searchTerm = "", readFilter = "all") {
  const q = normalizeText(searchTerm.trim());

  return messages.filter((message) => {
    const isRead = Boolean(message?.read_message);

    const matchesReadFilter =
      readFilter === "all" ||
      (readFilter === "unread" && !isRead) ||
      (readFilter === "read" && isRead);

    const searchable = normalizeText(
      [
        message?.name,
        message?.email,
        message?.message,
        message?.section?.nom_section,
      ]
        .filter(Boolean)
        .join(" ")
    );

    const matchesSearch = !q || searchable.includes(q);

    return matchesReadFilter && matchesSearch;
  });
}

export function getMessagesStats(messages = []) {
  const total = messages.length;
  const unread = messages.filter((message) => !message.read_message).length;
  const read = total - unread;

  const latestMessage = sortMessagesByDate(messages)[0];

  return {
    total,
    unread,
    read,
    latestDate: latestMessage ? getMessageDate(latestMessage) : null,
  };
}

export function buildMailtoUrl(message) {
  const email = message?.email || "";

  if (!email) return "#";

  const subject = encodeURIComponent("Réponse à votre message");
  const body = encodeURIComponent(
    `Bonjour ${message?.name || ""},\n\nNous faisons suite à votre message envoyé via le formulaire de contact.\n\nVotre message :\n"${message?.message || ""}"\n\nCordialement,`
  );

  return `mailto:${email}?subject=${subject}&body=${body}`;
}